<template>
  <div class="data-source-privite props-group">
    <el-form-item label="来源">
      <el-select v-model="component.properties.dataSourceData.dataSource"
                 @change="updataDataSource"
                 placeholder="请选择"
                 filterable
                 clearable>
        <el-option
          v-for="item in dataSourceReports"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="展示字段">
      <el-select v-model="component.properties.dataSourceData.showColumnId" placeholder="请选择" filterable clearable>
        <el-option
          v-for="item in columns"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <div class="data-binding">数据绑定</div>
    <template v-for="(dataSource, index) in component.properties.dataSourceData.dataBinding">
      <div class="binding-detail" :key="index">
        <div class="title">
          添加绑定
          <i class="el-icon-close" @click="remove(index)"></i>
        </div>
        <el-form-item class="content" label="选择字段">
          <el-select v-model="dataSource.showColumnId" placeholder="请选择" filterable clearable>
            <el-option
              v-for="item in columns"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="content" label="选择控件">
          <el-select v-model="dataSource.componentId" placeholder="请选择" filterable clearable>
            <el-option
              v-for="item in getComponentName"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </template>
    <div class="add-binding" @click="addBinding">+ 添加绑定</div>
  </div>
</template>

<script>
export default {
  name: 'attr-data-source-privide',
  props: ['component'],
  inject: ['formService'],
  data () {
    return {
      columns: []
    }
  },
  created () {
    if (this.component.properties.dataSourceData.dataSource) {
      this.searchColumns(this.component.properties.dataSourceData.dataSource)
    }
  },
  methods: {
    // 查询所有辅助表的列信息
    searchColumns (tableId) {
      this.columns = []
      this.formService.loadDataReport(tableId).then((data) => {
        if (data.columns) {
          this.columns = data.columns
        }
      })
    },
    // 增加绑定
    addBinding () {
      if (this.component.properties.dataSourceData.dataSource) {
        this.component.properties.dataSourceData.dataBinding.push({
          'showColumnId': '',
          'componentId': ''
        })
      }
    },
    // 删除绑定
    remove (index) {
      this.component.properties.dataSourceData.dataBinding.splice(index, 1)
    },
    updataDataSource (val) {
      if (val) {
        this.searchColumns(val)
      }
      this.component.properties.dataSourceData.dataBinding = []
      this.component.properties.dataSourceData.showColumnId = ''
    }
  },
  computed: {
    dataSourceReports () {
      return this.formService.options.dataSourceReports
    },
    getComponentName () {
      let table = this.$_.cloneDeep(this.formService.schema.tables.find(m => m.tableId === this.component.archive.tableId))
      if (table && table.columns) {
        let componentIds = []
        this.component.properties.dataSourceData.dataBinding.forEach(m => {
          componentIds.push(m.componentId)
        })
        table.columns.forEach(m => {
          m.disabled = !componentIds.indexOf(m.id)
        })
        return table.columns
      }
    }
  }
}
</script>

<style lang="scss">
  .data-source-privite {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
    .data-binding {
      font-size: 12px;
      color: #606266;
      margin-bottom: 14px;
    }
    .binding-detail {
      border: 1px solid #C2C3C4;
      border-radius: 4px;
      width: calc(100% + 20px);
      margin-left: -10px;
      margin-bottom: 14px;
      .title {
        margin-left: 10px;
        margin-right: 10px;
        font-size: 12px;
        color: #606266;
        border-bottom: 1px solid #C2C3C4;
        height: 30px;
        line-height: 30px;
        .el-icon-close {
          display: none;
          color: #FA4B4B;
          cursor: pointer;
          float: right;
          padding-top: 10px;
        }
      }
      .content {
        padding-left: 10px;
        padding-right: 10px;
      }
      &:hover {
        border: 1px solid #ADDAFE;
        .el-icon-close {
          display: inline;
        }
      }
    }
    .add-binding {
      text-align: center;
      font-size: 12px;
      color: #54ABF1;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/data-source-privide.vue